import { makeStyles, tokens } from "@fluentui/react-components";
import { MainDialogMaxWidth, MainDialogMinWidth, MainDialogWidth } from "@ms/uno-constants/lib/local/ModalConstants";
/**
 * Base styles applicable for all dialogs in Planner.
 */ export const usePlannerAppDialogStyles = makeStyles({
    surface: {
        color: tokens.colorNeutralForeground1,
        backgroundColor: tokens.colorNeutralBackground1,
        width: MainDialogWidth,
        maxWidth: MainDialogMaxWidth,
        minWidth: MainDialogMinWidth,
        boxShadow: "rgba(0, 0, 0, 0.4) 0px 0px 5px 0px"
    },
    title: {
        fontWeight: tokens.fontWeightSemibold
    },
    dialogButton: {
        borderRadius: tokens.borderRadiusXLarge,
        minWidth: "auto"
    }
});
